import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {SidePanelHeader} from '../inboxes/side/sidePanelHeader';
import {KeyboardHelpContent} from './keyboardHelpContent';

interface KeyboardHelpProps {}

/*
 * Component.
 */

export const KeyboardHelp: FC<KeyboardHelpProps> = (props) => (
  <>
    <SidePanelHeader title={<Trans id="sidepanel-keyboardhelp-title">Keyboard Shortcuts</Trans>} />
    <KeyboardHelpContent />
  </>
);
